import * as React from 'react';

function SvgCheckFilled(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 21 21" fill="none" {...props}>
      <ellipse cx={10.5} cy={10.5} rx={10.5} ry={10.5} fill={props.color} />
      <path
        d="M6.892 10.323l2.174 2.195a1 1 0 001.42 0l4.982-5.027"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgCheckFilled;
